export const blockIconsCommunicationMessage = (
	<span className='material-symbols-outlined'>message</span>
);
